import { COMPANY_PARAMETER } from 'utils/constants/constants';

export enum AppRoutesEnum {
  HOME = '/',
  NOT_FOUND = '/not-found',
  INVOICES = '/expenses',
  INVOICES_APPROVAL = '/expenses-approval',
  INVOICES_ACCOUNTING = '/expenses-accounting',
  INVOICES_PAYMENT = '/expenses-payment',
  COMPANY_INVOICES = `/companies/${COMPANY_PARAMETER}/expenses`,
  COMPANY_INVOICES_APPROVAL = `/companies/${COMPANY_PARAMETER}/expenses-approval`,
  COMPANY_INVOICES_ACCOUNTING = `/companies/${COMPANY_PARAMETER}/expenses-accounting`,
  COMPANY_INVOICES_PAYMENT = `/companies/${COMPANY_PARAMETER}/expenses-payment`,
  INVOICE_VERIFICATION = `/companies/${COMPANY_PARAMETER}/expenses/:id`,
  REVENUE = '/revenue',
  COMPANY_REVENUE = `/companies/${COMPANY_PARAMETER}/revenue`,
  REVENUE_VERIFICATION = `/companies/${COMPANY_PARAMETER}/revenue/:id`,
  ADD_COMPANY = '/companies/add',
  COMPANY_DETAILS = `/companies/${COMPANY_PARAMETER}/details`,
  COMPANY_DASHBOARD = `/companies/${COMPANY_PARAMETER}/dashboard`,
  DASHBOARD = '/dashboard',
  COMPANY_COUNTERPARTIES = `/companies/${COMPANY_PARAMETER}/counterparties`,
  COMPANY_COUNTERPARTIES_NEW = `/companies/${COMPANY_PARAMETER}/counterparties/new`,
  COMPANY_COUNTERPARTIES_EDIT = `/companies/${COMPANY_PARAMETER}/counterparties/:counterpartyId/edit`,
  COMPANY_EXPENSE_TYPES = `/companies/${COMPANY_PARAMETER}/expense-types`,
  COMPANY_BUDGETING = `/companies/${COMPANY_PARAMETER}/budget`,
  COMPANY_PAYROLL = `/companies/${COMPANY_PARAMETER}/payroll`,
  COMPANY_APPROVAL_RULES = `/companies/${COMPANY_PARAMETER}/approval-rules`,
  COMPANY_APPROVAL_RULES_NEW = `/companies/${COMPANY_PARAMETER}/approval-rules/new`,
  COMPANY_APPROVAL_RULES_EDIT = `/companies/${COMPANY_PARAMETER}/approval-rules/:ruleId/edit`,
  USER_MANAGEMENT = '/user-management',
  COMPANY_USER_MANAGEMENT = `/companies/${COMPANY_PARAMETER}/user-management`,
  INVOICE_VERIFICATION_STEPPER = `/companies/${COMPANY_PARAMETER}/expenses/:id/verification-stepper`,
  COMPANY_COUNTERPARTIES_NOT_VALIDATED = `/companies/${COMPANY_PARAMETER}/not-validated`,
  PROMPT_BASED_REPORTING = `/prompt-based-reporting`,
  COMPANY_PROMPT_BASED_REPORTING = `/companies/${COMPANY_PARAMETER}/prompt-based-reporting`
}
